import { produce } from 'immer';
import { ItemTypes, uuid } from '../constants/constants';
import { mutateCreateMask, mutateInjectMask } from '../utils/masks';
import { mutateMoveBoxFromGroup } from '../utils/boxes';
import { hasPageBackgroundFill } from '../utils/pageBackgroundFill';

export const masksActions = (set, get) => ({
  updateMask: ({ id, fn }) => {
    set(
      produce((draft) => {
        const mask = draft.masks.find((c) => c.id === id);
        fn(mask, draft);
        // Le décor de page ne prend pas de fond, quel que soit l'appelant.
        const updated = draft.masks.find((c) => c.id === id);
        if (hasPageBackgroundFill(updated)) delete updated.backgroundColor;
      }),
      false,
      `update Mask ${id}`
    );
  },
  deleteMask: (id) => {
    set(
      produce((state) => {
        state.masks = state.masks.filter((mask) => mask.id !== id);
      }),
      false,
      'deleteMask'
    );
  },
  renameMask: (id, name) => {
    set(
      produce((state) => {
        state.masks.forEach((mask) => {
          if (mask.id === id) {
            mask.name = name;
          }
        });
      }),
      false,
      'renameMask'
    );
  },
  setEditableMask: (id, editableValue) => {
    set(
      produce((state) => {
        state.masks.forEach((mask) => {
          if (mask.id === id) {
            mask.editableMask = editableValue;
          }
        });
      }),
      false,
      'setEditableMask'
    );
  },
  duplicateMask: (id, name) => {
    set(
      produce((state) => {
        const duplicatedMask = state.masks.find((mask) => mask.id === id);
        const maskDuplicatedId = uuid();
        const duplicatedMaskBoxes = duplicatedMask.boxes.map((box) => {
          return {
            ...box,
            id: uuid(),
            maskId: maskDuplicatedId,
          };
        });

        state.masks = [
          ...state.masks,
          { id: maskDuplicatedId, name, boxes: duplicatedMaskBoxes },
        ];
      }),
      false,
      'duplicateMask'
    );
  },
  // Masque fixe (décor de page) absent des documents créés avant lui : ajouté
  // vide, une seule fois, au moment de l'éditer.
  addMissingMask: (maskType) => {
    if (get().masks.some(({ id }) => id === maskType.id)) return;
    set(
      produce((state) => {
        state.masks.push({ ...maskType, boxes: [] });
      }),
      false,
      `addMissingMask ${maskType.id}`
    );
  },
  togglePageBackgroundMargins: () => {
    set(
      produce((state) => {
        state.hidePageBackgroundMargins = !state.hidePageBackgroundMargins;
      }),
      false,
      'togglePageBackgroundMargins'
    );
  },
  createMask: ({ name }) => {
    set(
      produce((draft) => {
        mutateCreateMask({ draft, name });
      }),
      false,
      'createMask'
    );
  },
  setMaskEditing: (ids) => {
    set(
      produce((state) => {
        state.maskEditing = ids;
        state.selectedBoxId = null;
        state.boxVariableSelectedId = null;
      }),
      false,
      `setMaskEditing ${ids.join(', ')}`
    );
  },
  moveMaskBox: (left, top, boxId, maskId) => {
    set(
      produce((state) => {
        const boxes = state.masks.find((mask) => mask.id === maskId).boxes;
        const box = boxes.find((box) => box.id === boxId);
        if (box.type === ItemTypes.GROUP_BOXES) {
          mutateMoveBoxFromGroup({
            box,
            boxes,
            newLeft: left,
            newTop: top,
            oldLeft: box.left,
            oldTop: box.top,
          });
        }
        box.top = top;
        box.left = left;
      }),
      false,
      'moveMaskBox'
    );
  },
  injectMask: ({ id, boxId }) => {
    set(
      produce((state) => {
        mutateInjectMask({ draft: state, maskId: id, boxId });
      }),
      false,
      'injectMask'
    );
  },
});
